<div class="modal-header">
  <h5 class="modal-title">Create user</h5>
  <button type="button" class="btn btn-link close pull-right" aria-label="Close" (click)="close()">
    <i class="fa fa-lg fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">

    <div class="col-24">
      <label>Email</label>
      <input class="form-control" name="email" type="email" formControlName="email">
    </div>

    <div class="col-24">
      <label>Password</label>
      <input class="form-control" name="password" type="password" placeholder="Password" formControlName="password">
    </div>

    <div class="col-24">
      <label>Password again</label>
      <input class="form-control" name="passwordAgain" type="password" placeholder="Password again" formControlName="passwordAgain">
    </div>

  </form>
</div>
<div class="modal-footer">
  <button class="btn btn-primary"
          (click)="submit()"
          [disabled]="form.invalid">
    <i class="fa fa-lg fa-plus-circle"></i>
    Submit
  </button>

  <button class="btn btn-outline-primary"
          (click)="close()">
    Close
  </button>
</div>
